// Independent individual step sequence. Numbers reference shared wizard shell slots,
// not company workflow rules. Slot 6 captures employment instead of company collateral.
export const individualJourneySteps = [
  {index: 0, label: 'Customer Type'}, {index: 1, label: 'Customer Search'},
  {index: 2, label: 'Individual Details'}, {index: 3, label: 'Income and Expenses'},
  {index: 8, label: 'Affordability'}, {index: 9, label: 'Loan Request'},
  {index: 4, label: 'Contact Details'},
  {index: 6, label: 'Employment Details'},
  {index: 5, label: 'Bank Details'}, {index: 7, label: 'Review'}
];
export function individualNextStep(step: number) {
  return individualJourneySteps[individualJourneySteps.findIndex(item => item.index === step) + 1]?.index ?? 7;
}
export function individualPreviousStep(step: number) {
  return individualJourneySteps[individualJourneySteps.findIndex(item => item.index === step) - 1]?.index ?? 0;
}
